import * as React from 'react';
import { SVGProps } from 'react';

const IconAreaChartSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M10.5 8.577V10.5H3.112l.227-.21L7.25 6.68l1.91 1.764.145.133H10.5ZM2.66 10.29l.228.21H1.5V9.219l.16.148 1 .923Z" />
  </svg>
);
export default IconAreaChartSizeXs;
